import { render, staticRenderFns } from "./EciButton.vue?vue&type=template&id=386242b1&scoped=true&"
import script from "./EciButton.vue?vue&type=script&lang=js&"
export * from "./EciButton.vue?vue&type=script&lang=js&"
import style0 from "./EciButton.vue?vue&type=style&index=0&id=386242b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386242b1",
  null
  
)

export default component.exports